import styled from 'styled-components'

const Box = styled.div`
  border: 4px solid var(--main-color);
  border-radius: 1rem;
  padding: 8px 12px;
  font-weight: 700;
  text-transform: capitalize;
  font-size: 1.6rem;
  color: ${(props) => (props.dark ? '#5b5b5b' : 'var(--white)')};
`

const InfoBox = ({ info, dark }) => {
  return <Box dark={dark}>{info}</Box>
}

export default InfoBox
